// A world that models languages as a skill names that skill in a `languageSkill` build-option
// modification's `element`. A world running the BINARY variant — where a language is simply known
// or not known, with no die rank — declares that by nulling `element` and writing this sentinel
// into the same modification's `label`.
//
// This module is the single source of truth for that marker. It is store-free so it can be
// imported by both the authoring component and the apply handler without a cycle, following
// armor-stacking.ts.
//
// Why a sentinel rather than a bare null element: `element` is also null for a modification the
// author has added but not yet pointed at a skill. The two states have to be told apart, because
// the declaration CLEARS a skill inherited from an earlier setting rule while the half-configured
// one must leave it alone.
//
// Why a stable marker rather than the localized display string: the comparison is an exact match,
// so a label left over from an earlier skill pick cannot masquerade as a declaration, and the
// meaning does not shift when the UX labels change.
export const NO_LANGUAGE_SKILL = 'none';
